import { ReducerAction, State } from '../'
import { Topic } from '../interfaces/types'

export enum TopicActions {
  update = 'update-topic',
  remove = 'remove-topic',
  updateMultiple = 'updateMultiple-topic',
}

export function topicReducer(state: State, action: ReducerAction) {
  switch (action.type) {
    case TopicActions.update: {
      const { ignoreNotFound, id, data } = action.payload
      if (!id && !data?.id) return state
      const _id = id || data.id
      if (ignoreNotFound && !state.topicsById[_id]) return state
      return {
        ...state,
        topicsById: {
          ...state.topicsById,
          [_id]: {
            ...state.topicsById[_id],
            ...(typeof data === 'function'
              ? data(state.topicsById[_id])
              : data),
          },
        },
      }
    }
    case TopicActions.updateMultiple: {
      const { ignoreNotFound, dataArr = [] } = action.payload
      const { topicsById } = state
      dataArr.forEach((data: Topic) => {
        if (!data.id) return
        if (ignoreNotFound && !topicsById[data.id]) return state
        topicsById[data.id] = {
          ...topicsById[data.id],
          ...data,
        }
      })
      return {
        ...state,
        topicsById: {
          ...topicsById,
        },
      }
    }
    case TopicActions.remove: {
      const { id } = action.payload
      if (!id) return state
      const { topicsById } = state
      delete topicsById[id]
      return {
        ...state,
        topicsById: {
          ...topicsById,
        },
      }
    }
    default: {
      return state
    }
  }
}
